import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClcdContent, ClcdService } from './clcd.service';
import { finalize } from 'rxjs/operators';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CarouselItem } from '../../../../components/carousel/carousel.service';

@Component({
  selector: 'ag-clcd',
  templateUrl: './clcd.component.html',
  styleUrls: ['./clcd.component.scss'],
})
export class ClcdComponent implements OnInit {
  @Input() clcd: string;
  @Input() label = 'CLCD';
  @Input() searchId: string;
  @Output() contentLoaded = new EventEmitter<boolean>(false);

  content: ClcdContent;
  carouselItems: CarouselItem[] = [];
  hasContent: boolean;

  constructor(
    private _clcdService: ClcdService,
    private _analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    if (this.clcd) {
      this._clcdService
        .getClcdContent(this.clcd, this.searchId)
        .pipe(finalize(() => this.hasContentLoaded()))
        .subscribe((response) => {
          this._analyticsService.logEvent('CLCD Display');
          this.content = response;
          if (this.content.booksLikeThis) {
            this._clcdService
              .getBooksLikeThis(this.content.booksLikeThis)
              .pipe(finalize(() => this.hasContentLoaded()))
              .subscribe((response) => {
                this.carouselItems = response.items;
              });
          }
        });
    }
  }

  hasContentLoaded() {
    this.hasContent =
      this.content?.age != null ||
      this.content?.awards?.length > 0 ||
      this.content?.reviews?.length > 0 ||
      this.content?.studyProgram != null ||
      this.carouselItems?.length > 0;
    this.contentLoaded.emit(this.hasContent);
  }
}
